import Vue from '/vodalys/vvuejs/vue'
import { debounce } from "/vodalys/.jslibs/";

const resizeObserverDirective = {
    bind(el, binding, vnode) {

        const {
            width, height
        } = el.getBoundingClientRect();

        binding.value({
            width, height
        }, el);

        if (!ResizeObserver) {
            console.warn('ResizeObserver is not supported in your browser')
            return
        }

        const observer = new ResizeObserver(debounce(entries => {
            const entry = entries[0];
            const newSize = {
                width: entry.contentRect.width,
                height: entry.contentRect.height
            };
            binding.value(newSize, el);
        }, 125));
        observer.observe(el);
        el._resizeObserver = observer;
    },
    unbind(el, binding, vnode) {
        const observer = el._resizeObserver;
        if (observer) {
            observer.disconnect();
            delete el._resizeObserver;
        }
    }
};

Vue.directive('resize-observer', resizeObserverDirective);
